import type { ValidationIssueFamily } from './validationIssueFamilies';
import { buildEndTypeSlotSwapQuickFillHandoff } from './validationQuickFillRepairMetadata';

export function buildEndTypeSlotSwapQuickFillFamily(
  family: ValidationIssueFamily
): ValidationIssueFamily | null {
  const handoff = buildEndTypeSlotSwapQuickFillHandoff(family.rawIssues);
  if (!handoff) {
    return null;
  }

  return {
    ...family,
    id: `${family.id}:end-type-slot-swap-quick-fill`,
    targetPage: 'quick-fill',
    targetLabel: 'Quick Fill',
    primaryAction: {
      label: 'Open Quick Fill for safe slot swaps',
      route: 'quickFillProperties',
      type: 'navigate',
      params: {
        quickFillFocus: handoff.quickFillFocus,
      },
    },
    affectedItems: handoff.quickFillFocus.labels,
    affectedCount: handoff.issues.length,
    impactedElementIds: handoff.elementIds,
    impactedElementCount: handoff.elementIds.length,
    rawIssues: handoff.issues,
    issueCount: handoff.issues.length,
  };
}
